module.exports = __webpack_public_path__ + "img/balloon1_n.6f1c4f53.png";